<template>
    <div class="content-area__heading">
            <top-nav>
                <div slot="title">
                    <h2 >Net Promoter Score</h2>
                </div>
            </top-nav>
            <vx-card v-for="(item,key) in estatisicas" v-bind:key="key+1" :title="item.title" :subtitle="item.subtitle"
                collapse-action :refresh-content-action="item.show_refresh" 
                :download-card-action="item.show_download" :close="true" 
                v-on:download="function(){ 
                    item.download = true 
                    $nextTick(() => {
                        item.download = false 
                    }) 
                }" 
                v-on:refresh="function(){
                    item.refresh = true 
                    $nextTick(() => {
                        item.refresh = false 
                    })
                }"
                v-on:toggle="function(close) { 
                    close == false ? item.loading = true : 0 
                    close == false ? item.show_refresh = true : item.show_refresh = false
                    close == false ? 0 : item.show_download = false, 
                    item.close = true
                    $nextTick(() => {
                        item.close = false
                    })
                }">
                <div>
                    <estatisticas v-if="item.title == 'Sistema' && item.loading" type="sistema" 
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas>
                    <estatisticas v-if="item.title == 'Revendedor' && item.loading" type="revendedor"
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas>
                    <estatisticas v-if="item.title == 'Time de apoio' && item.loading" type="apoio"
                        :refresh="item.refresh" :download="item.download" 
                        :close="item.close" v-on:download="(status) => item.show_download = status">
                    </estatisticas>
                </div>
            </vx-card>
    </div>
</template>

<script>
export default {
    components:{
        TopNav: () => import("../../components/nav-bar/top-nav"),
        Estatisticas: () => import("./components/Estatisticas"),
    },
    data:() => ({
        estatisicas:{
            sistema:{
                title:"Sistema",
                subtitle:"",
                loading:false,
                refresh:false,
                download:false,
                show_download:false,
                close:false,
            },
            revendedor:{
                title:"Revendedor",
                subtitle:"",
                loading:false,
                refresh:false,
                download:false,
                show_download:false,
                close:false,
            },
            apoio:{
                title:"Time de apoio",
                subtitle:"",
                loading:false,
                refresh:false,
                download:false,
                show_download:false,
                close:false,
            },
        }
    })
}
</script>